var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"client-app"}},[_c('pc-singleton-modals',{attrs:{"id":"singleton-client-modals"}}),_c('pc-singleton-overlay',{attrs:{"id":"singleton-client-overlay"}}),_c('pc-singleton-snackbar',{attrs:{"id":"singleton-client-snackbar"}}),(
        _vm.initialAuthenticationRequestComplete &&
        _vm.$store.state.authenticatedUser &&
        _vm.$store.state.authenticatedUser.isClient()
      )?_c('div',{staticClass:"fill-height pc-client-app-container"},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }